export default {
  "meeting": {
    applyrecurring: '변경 사항은 새로운 반복 일정에 적용되며, 이전 회의에는 영향을 주지 않습니다.',
    recurrenceDescribeTwo: '{start}부터 {end}까지 {loopPulse}주마다 {week}에 반복',
    wanttodeletethemeetingfollowTwo: '선택한 회의와 이후의 모든 반복 회의를 삭제하시겠습니까?',
    loopCycleSelectTips: '반복할 요일을 선택하세요.',

    export: '내보내기',
    exportMeetingFileFuncTipsTitle: '내보내기 확인',
    exportMeetingFileFuncTipsContentOne: '필터가 적용되지 않았습니다. 시스템은 기본적으로 올해의 회의 기록을 내보냅니다.',
    exportMeetingFileFuncTipsContentTwo: '다른 기간의 회의를 내보내려면 내보내기 전에 원하는 필터를 적용하세요.',

    myMeetingSearch: '내 회의',
    meetingTimeSearch: '회의 시간',
    meetingRoomsSearch: '회의실',

    Recurring: '반복:',
    wanttodeletethemeetingfollow: '이 회의와 이후의 모든 회의를 삭제하시겠습니까?',
    endTimeCannotBeforeBeginTime: '종료 날짜는 시작 날짜보다 빠를 수 없습니다',
    Thismeeting: '이 회의',
    Recurringmeeting: '반복 회의',
    Checkin: '체크인:',
    checkinTip: '활성화하면 참석자는 회의실 예약 QR 코드를 스캔하여 체크인할 수 있습니다.',
    Recurrence_Setrecurrence: '반복 설정',
    Recurrence_Start: '시작',
    Recurrence_RepeatEvery: '반복 주기',
    Recurrence_Week: '주',
    Recurrence_end: '종료',
    recurrenceDescribe: '{week}마다 반복, {start}부터 {end}까지',
    Recurrence_DoesnotRepeat: '반복 안 함',
    Recurrence_Weekly: '매주',

    AddressBookUser: '사용자',
    AddressBookPhonebook: '주소록',

    RoomByPeopleNum1: '2명 이하',
    RoomByPeopleNum2: '3-6명',
    RoomByPeopleNum3: '7-10명',
    RoomByPeopleNum4: '11-15명',
    RoomByPeopleNum5: '16-20명',
    RoomByPeopleNum6: '21-30명',
    RoomByPeopleNum7: '30명 이상',

    whoAreBound: '시스템 계정에 연결된 사용자는 시스템 일정에서 회의를 확인할 수 있습니다. 이메일을 입력한 사용자는 이메일로 회의 알림을 받습니다. 알림을 받으려면 [내 프로필]에서 이메일 정보를 입력하세요.',

    AttendessMeeting: '참석자:',
    SelectAttendessMeetingTip: '참석자 선택',

    MeetingFilter: '회의 필터',
    HostedbyMe: '내가 주최',
    Invitedby: '내가 참여',
    Otherby: '기타',

    "AddressIsDuplicated": "연락처 이메일이 중복되었습니다",
    meetingExpired:'만료되었습니다',
    titlePhoneFormat: '전화는 숫자, () + 및 -만 입력할 수 있습니다.',
    "selectField": "파일을 선택하세요",
    "Limit255": "파일 이름은 255자를 초과할 수 없습니다",
    "nameLimit25": "이름은 25자를 초과할 수 없습니다",
    "emailLimit50": "이메일은 50자를 초과할 수 없습니다",
    "emailFormatError": "유효한 이메일 주소를 입력하세요",
    "phoneLimit11": "전화번호는 최대 11자리까지 입력할 수 있습니다",
    "ParticipantsEmail": "참가자 이메일:",
    "listIsEmpty": "목록이 비어 있습니다",
    "Startimporting": "업로드 시작",
    "Selectfile": "파일 선택",
    "Importfile": "파일 가져오기",
    "ImportfileTip": "*CSV (*.csv) 또는 vCard (*.vcf) 파일 가져오기 지원",
    "addParticipants": "참가자 추가",
    "multiselectdeselect": "태그 삭제 안내",
    "multiselectselected": "선택됨 안내",
    "enterOrSelectALabel": "참가자 이메일 선택",
    "deleTitleContact": "이 연락처를 삭제하시겠습니까?",
    "delTitleContactContent": "연락처 삭제?",
    "deleteContactTitle": "삭제할 연락처를 선택하세요",
    "editcontact": "연락처 편집",
    "Name": "이름",
    "email": "이메일",
    "telephoneNumber": "전화",
    "Addcontact": "연락처 추가",
    "Importcontactfile": "연락처 가져오기",
    "AddressBook": "주소록",
    "Participants": "참가자:",

    "bindTipContent": "이 조직은 이미 서드파티 캘린더에 연결되어 있습니다. Outlook/Teams를 통해 회의를 예약하세요.",
    "Productupdatenews": "새 버전 업데이트가 출시되었습니다.",
    "bookingPerson": "예약자",
    "DeleteMeeting": "회의 삭제",
    "wanttodeletethemeeting": "회의를 삭제하시겠습니까?",
    "hasbeendeleted": "회의가 삭제되었습니다",
    "theMeetingWasAborted": "회의 조기 종료",
    "theMeetingWasAbortedContent": "회의를 조기 종료하시겠습니까?",
    "determineTheAbortTask": "회의 조기 종료",
    "theMeetingEndedEarly": "회의가 조기 종료되었습니다",
    "with": "함께",
    "Other": "기타",
    "tasks": "작업",
    "conflict": "충돌",
    "meetConflicts": "다음 회의 시간이 겹칩니다:",
    "itIsNotAllowedToSelectThePastTime": "과거 시간은 선택할 수 없습니다",
    "selected": "선택됨",
    "noOverFive": "회의실은 최대 5개까지 선택 가능",
    "approvalOpinions": "승인 의견",
    "beyondTheTimeLimitItCannotBeSelected": "시간 제한을 초과하면 선택할 수 없습니다",
    "startMonth": "시작 월",
    "to": "까지",
    "stopMonth": "종료 월",
    "didnTStart": "시작되지 않음",
    "ONGOING": "진행 중",
    "ENDED": "종료됨",
    "hasBeen": "예약됨",
    "booking": "예약",
    "Approval": "승인",
    "MeetingRoom": "회의실",
    "AllRoom": "모든 방",
    "Available": "사용 가능",
    "Initiate": "회의 시작",
    "MeetingApproval": "회의 승인",
    "PreviousMonth": "지난 달",
    "Today": "오늘",
    "NextMonth": "다음 달",
    "YearMonth": "연/월",
    "TimeDisplay": "시간 표시",
    "MeetingTitleAbbreviation": "회의 제목 약어",
    "InitiateMeeting": "회의 시작",
    "PendingMeetings": "예정된 회의",
    "AllMeetings": "모든 회의",
    "noMeetings": "현재 참석할 회의가 없습니다",
    "NotStarted": "시작되지 않음",
    "Organizer": "주최자",
    "MeetingDateTime": "날짜 및 시간",
    "MeetingLocation": "장소",
    "MeetingSubject": "회의 주제",
    "Invited": "초대됨",
    "PeopleAccepted": "참석 승인된 사람",
    "EditMeeting": "회의 편집",
    "CancelMeeting": "회의 취소",
    "InitiateEditMeeting": "회의 시작/편집",
    "Subject": "주제",
    "Presenter": "발표자:",
    "DateTime": "날짜 및 시간",
    "TimeAndZone": "시간대",
    "Attendees": "참석자",
    "Addrequiredattendees": "필수 참석자 추가",
    "SelectRooms": "회의실 선택",
    "Reminder": "알림",
    "Remindbeforestart": "시작 전에 알림",
    "Confirm": "확인",
    "topic": "주제:",
    "topicplace": "새 회의 제목:",
    "speaker": "발표자:",
    "speakerplace": "발표자 정보를 입력하세요",
    "DateAndTime": "날짜 및 시간:",
    "TimeZone": "시간대",
    "EndDate": "종료일",
    "Rooms": "회의실:",
    "Notes": "비고:",
    "MeetingRoomApproval": "회의실 승인",
    "PendingApproval": "승인 대기",
    "Approved": "승인됨",
    "nopendingapprovals": "승인 대기 없음",
    "Applicant": "신청자",
    "UsageTime": "사용 시간",
    "ApprovalResult": "승인 결과",
    "ApprovalComments": "승인 코멘트",
    "Approve": "승인",
    "Reject": "거절",
    "Search": "검색",
    "Filter": "필터",
    "scanTheQRCodeToSignIn": "출석 확인을 위해 QR 코드 스캔"
  },
  "NPS": {
    "Relay": "릴레이",
    "RelaySettings": "릴레이 설정",
    "DevicePower": "장치 전원 제어",
    "DeviceElevation": "엘리베이션 제어",
    "LinageWithNPSPower": "NPS 전원과 연동",
    "PresentationSwitch": "프레젠테이션 스위치",
    "Duplicate": "복제",
    "LinkagewithNPSPowe": "NPS 전원과 연동",
    "npsTooltip": "USB 장치는 HDMI OUT 1로 전환된 PC 호스트에서만 호출할 수 있습니다.",
    "nmpTooltip": "복제' 버튼을 클릭하면 다른 디스플레이에 화면 내용을 미러링하여 여러 화면에서 표시를 동기화합니다."
  },
  "textTemplate": {
    "template2513": "화재 비상 방송",
    "template2514": "화재 대피 계획에 따라 비상구 및 화재 출구에서 안전한 장소로 대피하십시오.",
    "moreTemplate": "템플릿 한도에 도달했습니다",
    "add": "추가",
    "SetTemplate": "템플릿 설정",
    "Emergency": "비상",
    "General": "일반",
    "BroadcastDevices": "방송 장치:",
    "selectBroadcastDevices": "방송 장치를 선택하십시오",
    "All": "모두",
    "AddTemplate": "템플릿 추가",
    "EditTemplate": "템플릿 편집",
    "deleteTemplage": "선택한 템플릿을 삭제하시겠습니까?",
    "title": "템플릿 삭제",
    "selectTemplage": "템플릿을 선택하십시오!",
    "DeleteCancelled": "삭제가 취소되었습니다!",
    "DeletedSuccessfully": "삭제 성공!",
    "noData": "사용 가능한 템플릿이 없습니다. 오른쪽 상단을 클릭하여 템플릿을 추가하십시오.",
    "TemplateTitle": "템플릿 제목:",
    "BroadcastType": "방송 유형:",
    "BroadcastTypeDialog": "방송 유형:",
    "selectBroadcastType": "방송 유형을 선택하십시오",
    "BroadcastDuration": "방송 기간:",
    "BroadcastDevice": "방송 장치:",
    "BroadcastContent": "방송 내용:"
  },
  "common": {
    "mediaTimeStateNotifyErrorTitle": "오류!",
    "mediaTimeStateNotifyErrorContent": "스트리밍 서비스가 만료되었습니다. 대리점에 연락하여 제때 갱신하십시오.",
    "mediaTimeStateNotifyWarnTitle": "주의!",
    "mediaTimeStateNotifyWarnContent": "현재 체험 상태이며, 방송 및 라이브 스트리밍은 최대 3대의 단말기에만 전송 가능합니다.",
    "mediaTimeStateNotifySuccessTitle": "갱신 성공",
    "mediaTimeStateNotifySuccessContent": "스트리밍 서비스가 정상적으로 사용 가능합니다. 감사합니다.",
    "company": "회사명:",
    "tableAddress": "주소:",
    "createTime": "생성일:",
    "email": "이메일:",
    "phone": "전화:",
    "Trial": "체험",
    "TrialWorkstation": "현재 체험 상태이며, 방송 및 라이브 스트리밍은 최대 3대의 단말기에만 전송 가능합니다.",
    "Normal": "정상",
    "NormalWorkstation": "스트리밍 서비스 유효 기간은",
    "to": "까지",
    "Advent": "시작",
    "AdventWorkstationOne": "스트리밍 서비스는",
    "AdventWorkstationTwo": "에 만료됩니다. 정상 사용을 위해 대리점에 연락하여 갱신하십시오.",
    "Expired": "만료",
    "ExpiredWorkstation": "스트리밍 서비스가 만료되었습니다. 대리점에 연락하여 제때 갱신하십시오."
  },
  "route": {
    "dashboard": "대시보드",
    "i18n": "I18n",
    "Devices": "장치",
    "Broadcast": "방송",
    "Schedule": "일정",
    "Resources": "리소스",
    "Live": "스트리밍",
    "meetings": "회의"
  },
  "navbar": {
    "updates": "최신 업데이트",
    "logOut": "로그아웃",
    "screenfull": "전체 화면",
    "oprofile": "내 프로필",
    "settings": "설정",
    "language": "언어",
    "BackTianwa": "티안와로 돌아가기",
    "newUserGuide": "신규 사용자 가이드"
  },
  "feedback": {
    "Feedback": "피드백",
    "email": "피드백을 위해 이메일을 남겨주세요.",
    "content": "제품 개선을 위한 의견과 메시지를 남겨주셔서 감사합니다.",
    "submit": "제출",
    "emailNoEmpty": "이메일은 비워둘 수 없습니다",
    "emailTrueRule": "올바른 이메일 형식을 입력하세요",
    "contentNoEmpty": "내용을 입력해주세요",
    "feedbackSuccess": "피드백 성공",
    "feedbackFailed": "피드백 실패",
    "emailNoChinese": "메일박스에 한글은 사용할 수 없습니다",
    "emailLength": "5~50자 사이로 입력해주세요",
    "emailSpecialString": "메일박스에 특수 문자열을 포함할 수 없습니다"
  },
  "login": {
    checkPasswordTitleTwo: '비밀번호는 6자 이상으로 설정하고, 영문자와 숫자를 포함해야 합니다. 특수문자는 제한 없이 사용할 수 있습니다.',
    captcha: '인증 코드',
    checkPasswordTitle: '비밀번호는 최소 6자 이상이며 숫자로만 구성될 수 없습니다',
    "title": "환영합니다",
    "logIn": "로그인",
    "consoleLogin": "콘솔 로그인",
    "username": "사용자 이름",
    "password": "비밀번호",
    "any": "임의",
    "thirdparty": "또는 연결",
    "thirdpartyTips": "로컬에서는 시뮬레이션할 수 없습니다. 따라서 자체 비즈니스 시뮬레이션과 결합하십시오!!!",
    "placeholder": "[\n  \"사용자 이름\",\n  \"비밀번호\",\n  \"인증 코드\"\n]",
    "userNameTitle": "사용자 이름이 잘못되었습니다!",
    "forget": "잊으셨나요?",
    "loginTitle0": "로그인 성공!",
    "loginTitle1000": "사용자 이름 또는 비밀번호가 잘못되었습니다!",
    "loginTitle1001": "사용자 이름과 비밀번호는 반드시 입력해야 합니다!",
    "loginTitle1002": "인증 코드를 반드시 입력해야 합니다!",
    "loginTitle1003": "사용자 상태가 올바르지 않아 로그인 실패!",
    "loginTitle1004": "인증 코드 오류!",
    "loginTitle1005": "로그인하지 않았습니다. 먼저 로그인하십시오!",
    "loginTitle1006": "두 비밀번호가 다릅니다!",
    "loginTitleUserName": "사용자 이름은 반드시 입력해야 합니다!",
    "loginTitlePwd": "비밀번호는 반드시 입력해야 합니다!",
    "loginTitleVercode": "인증 코드는 반드시 입력해야 합니다!",
    "titleLoginNameFormat": "계정은 문자 또는 문자와 숫자로 구성되어야 합니다.",
    "privacy": "Q-NEX User Privacy Policy",
    "privacyContent": "Agree to",
    "_zh": "中文(简体)",
    "_en": "_English",
    "_ko": "한국어",
    "_zh_ft": "中文(繁體)"
  },
  "home": {
    "btnDevices": "장치",
    "btnRoadcast": "방송",
    "btnResources": "리소스",
    "btnLive": "스트리밍",
    "meetings": "회의",
    "todaySchedule": "오늘 일정",
    "allSkedules": "모든 일정",
    "details": "세부 사항",
    "btnStart": "시작",
    "titleContent": "인사드립니다! Q-NEX 콘솔이 서비스를 제공합니다. 시작해 봅시다!",
    "btnExit": "종료"
  },
  "devices": {
    "ptzCamera": "PTZ 카메라",
    "start": "시작",
    "stop": "정지",
    "nmpPowerOff_mandatory": "방송 중(선택)",
    "nmpPowerOff_nomandatory": "방송 중(선택). 실행을 계속하시겠습니까?",
    "nmpsPowerOff_mandatory": "일부 NMP는 방송 중(필수)입니다.",
    "nmpsPowerOff_nomandatory": "일부 NMP는 방송 중(선택). 실행을 계속하시겠습니까?",
    "reset": "재설정",
    "displayedInTheControlArea": "제어 센터에 표시",
    "dragOrder": "드래그 순서",
    "areaSettingTwoNotice": "*RS232, AC 제어 및 리모컨은 대시보드에서 NMP 바인딩 상태에 따라 제어 센터에 표시됩니다.",
    "areaSettingThreeNotice": "*CBX 제어는 대시보드에서 NMP 바인딩 상태에 따라 제어 센터에 표시됩니다.",
    "controlSet": "제어 센터 설정",
    "vcbNoLine": "온라인 CBX 장치가 없습니다",
    "vcbNoBound": "CBX 장치가 바인딩되지 않았습니다",
    "tscNoBound": "TSC의 RS232가 데이터에 바인딩되어 있지 않습니다. 관리자에게 대시보드에서 바인딩하도록 알려주세요.",
    "light": "전원 제어",
    "vcbpower": "전원",
    "rs232Control": "시리얼 제어",

  "CBX": {
    "powerSupplyON": "전원 켬",
    "powerSupplyOFF": "전원 끔",
    "lockScreenON": "잠금 켬",
    "lockScreenOFF": "잠금 끔",
    "childLockON": "차일드락 켬",
    "childLockOFF": "차일드락 끔",
    "energySavingON": "절전 켬",
    "energySavingOFF": "절전 끔",
    "signalSourceSwitchingON": "OPS",
    "signalSourceSwitchingOFF": "Android",
    "volumeAdjustment": "스피커",
    "brightAdjustment": "밝기",
    "other": "기타 기능…"
  },

    "InterfaceOne": "인터페이스 1",
    "InterfaceTwo": "인터페이스 2",
    "abcStyleP": "죄송합니다! TSC와(NMP, MBX, NPS, NDP100, NDP500)는 동시에 선택할 수 없습니다",
    "masterControl": "메인",
    "powerSupply": "전원",
    "RecordingControl": "녹화 제어",
    "RecordingControlSystem": "강의 캡처 시스템",
    "LiquidCrystal": "인터랙티브 LCD 디스플레이",
    "projector": "프로젝터",
    "othertype": "기타",
    "lockScreen": "잠금",
    "childLock": "어린이 잠금",
    "energySaving": "절전",
    "signalSourceSwitching": "입력 소스",
    "volumeAdjustment": "스피커",
    "brightAdjustment": "밝기",
    "other": "기타 기능",
    "otherFunction": "기능",
    "send": "전송",
    "ON": "ON",
    "OFF": "OFF",
    "_POWERA": "Display Power",
    "_POWERB": "External Power",
    "_MAGNETICLOCK": "자기 시계",
    "_HDMI1": "HDMI in 1",
    "_HDMI2": "HDMI in 2",
    "_HDMI3": "HDMI in 3",
    "_HDMIA": "HDMI out A",
    "_HDMIB": "HDMI out B",
    "_HDMIC": "HDMI out C",
    "_AIR": "에어컨",
    "titleDevices": "그룹 필터:",
    "content": "검색",
    "selectALL": "전체 선택",
    "SelectRecentPage": "현재 페이지 선택",
    "controlPanel": "제어 센터",
    "displayInputSwitch": "디스플레이 입력 전환",
    "chooseINPUTSources": "입력 소스 선택",
    "speakerVolume": "오디오 볼륨",
    "bass": "베이스",
    "treble": "트레블",
    "MICVolume": "마이크 볼륨",
    "AirConditioning": "에어컨",
    "model": "모델",
    "setTemp": "온도 설정",
    "fanSpeed": "팬 속도",
    "bold": "스윙",
    "projectionScreen": "투사 스크린",
    "electronicLock": "전기 잠금",
    "electronicLock1": "전기 잠금",
    "selectDevices": "장치 또는 장치 그룹을 선택하세요",
    "isCompelType": "필수 방송으로 인해 장치 제어를 사용할 수 없습니다. 나중에 다시 시도하십시오.",
    "mainPower": "메인 전원",
    "extraPower": "추가 전원",
    "power": "전원",
    "hdmiBroadcast": "방송",
    "equipmentState1": "전원 켜기",
    "equipmentState2": "전원 끄기",
    "equipmentState3": "오프라인",
    "main": "메인",
    "external": "외부",
    "ProjectionScreen": "투사 스크린",
    "UP": "위",
    "DOWN": "아래",
    "LOCK": "잠금",
    "UNLOCK": "잠금 해제",
    "PleaseDevice": "왼쪽에서 장치를 선택하세요",
    "RemoteControl": "리모컨",
    "Action": "동작",
    "Devicefilter": "장치 필터",
    "DeviceStatus": "상태",
    "DeviceType": "유형",
    "currentAudioSource": "현재 오디오 소스",
    "audioSwitching": "오디오 출력 전환"
  },
  "broadcast": {
    "isBoarding": "(방송 중)",
    "last3Days": "지난 3일",
    "last7Days": "지난 7일",
    "last30Days": "지난 30일",
    "historyRecord": "기록",
    "SelectDestination": "1. 대상 선택",
    "BroadcastingConsole": "2. 방송 콘솔",
    "Notification": "알림",
    "btnStop": "정지",
    "btnStart": "시작",
    "Letters60": "(60자 미만)",
    "Letters300": "(300자 미만)",
    "LastingTime": "지속 시간:",
    "Title": "제목:",
    "Content": "내용:",
    "Cannotquit": "필수 방송",
    "ChooseMedia": "미디어 파일 선택",
    "Broadcasting": "방송 중",
    "dialogTitle": "비디오 & 오디오 리소스",
    "SortBy": "정렬 기준",
    "btnBake": "이전으로 돌아가기",
    "cancel": "취소",
    "confirm": "확인",
    "save": "저장",
    "coxAll": "전체",
    "PublicCloud": "공용 저장소",
    "IndividualCloud": "개인 저장소",
    "selFile": "파일 또는 그룹을 선택하세요.",
    "StopBroadcast": "방송 중지",
    "StartBroadcasting": "방송 시작",
    "StopBroadcasting": "방송 중지",
    "ForceQuit": "강제 종료",
    "PleaseMediaFile": "미디어 파일을 선택하세요",
    "PleaseDevice": "장치를 선택하세요",
    "broadcast_0": "방송 시작",
    "broadcast_2500": "미디어 서버에 연결 가능한 장치 수를 초과했습니다",
    "broadcast_2501": "방송 파일 오류",
    "broadcast_2502": "방송 종료",
    "broadcast_2503": "미디어 서버 정보를 가져올 수 없습니다",
    "broadcast_2510": "주의! 현재 체험 상태입니다. 최대 3대의 단말기만 방송 명령을 받을 수 있습니다. 선택한 장치 수를 확인하세요.",
    "broadcast_2018": "스트리밍 서비스가 종료되었습니다",
    "broadcast_2019": "스트리밍 서비스가 만료되었습니다",
    "broadcast_2512": "템플릿 수 제한을 초과했습니다.",
    "broadcast_2513": "화재 비상 방송",
    "broadcast_2514": "화재 대피 계획에 따라 비상구 및 화재 출구에서 안전한 장소로 대피하십시오.",
    "broadcast_2006": "장치를 찾을 수 없습니다",
    "broadcast_2": "디스크 서비스가 비정상입니다",
    "broadcast_2515": "방송 기능이 없는 장치를 선택하세요",
    "broadcast_2516": "NMP에서 지원되는 최대 해상도를 초과하는 파일을 선택하세요",
    "broadcast_2517": "NDP500에서 지원되는 최대 해상도를 초과하는 파일을 선택하세요",
    "broadcast_Title": "방송 경고",
    "broadcast_TitleNDP500": "NDP500 방송 경고",
    "broadcast_content": "장치는 최대 4K@30FPS를 지원하며, 최적 해상도는 1080P@30FPS입니다.",
    "broadcast_contentNDP500": "NDP500/600은 최대 1080P@30FPS를 지원하며, 최적 해상도는 720P@30FPS입니다.",
    "broadcast_noSupported": "선택된 다음 비디오는 방송을 지원하지 않습니다:",
    "broadcast_noSupportedNDP500": "선택된 다음 비디오는 NDP500/600에서 방송을 지원하지 않습니다:"
  },
  "resources": {
    "uploadNameLengthError": "업로드 파일 이름은 100자를 초과할 수 없습니다!",
    "onUploadFile": "업로드할 파일이 없습니다",
    "open": "열기",
    "fold": "접기",
    "close": "닫기",
    "PublicCloud": "공용 저장소",
    "IndividualCloud": "개인 저장소",
    "TransfersHistory": "전송 기록",
    "btnDownload": "다운로드",
    "btnDelete": "삭제",
    "btnUploadFile": "파일 업로드",
    "btnNewFolder": "새 폴더",
    "btnBake": "이전으로 돌아가기",
    "coxAll": "전체",
    "uploadError": "업로드 파일 크기는 1G를 초과할 수 없습니다!",
    "MD5": "MD5 확인",
    "merge": "병합 중",
    "transcoding": "트랜스코딩 중",
    "uploadFailed": "업로드 실패",
    "fileError": "파일 읽기 오류, 파일을 확인하세요.",
    "tableName": "이름",
    "tableSize": "크기",
    "tableType": "유형",
    "tableTimeAdded": "추가 시간",
    "tableAction": "작업",
    "btnRename": "이름 변경",
    "btnMoveTo": "이동...",
    "ClearAll": "모두 지우기",
    "cancel": "취소",
    "confirm": "확인",
    "save": "저장",
    "addSuccess": "추가 성공!",
    "addError": "추가 실패!",
    "editSuccess": "편집 성공!",
    "editError": "편집 실패!",
    "delSuccess": "삭제 성공!",
    "delError": "삭제 실패!",
    "diskError3000": "총 용량을 초과하여 작업 실패!",
    "diskError3001": "공용 공간 사용량 초과로 작업 실패!",
    "diskError3002": "개인 공간 사용량 초과로 작업 실패!",
    "diskError3003": "데이터를 찾을 수 없습니다. 미디어 서버가 바인딩되어 있는지 확인하세요!",
    "diskError3004": "폴더 이름이 이미 존재합니다!",
    "diskError3005": "폴더 가져오기 실패!",
    "diskError3006": "같은 수준에서 99개 이상의 폴더를 생성할 수 없습니다!",
    "diskError3007": "같은 파일 이름이 존재하여 수정 실패!",
    "diskError3008": "같은 폴더 이름이 존재하여 수정 실패!",
    "diskError3009": "파일이 남은 용량을 초과하여 업로드 실패!",
    "diskError3010": "업로드 실패!",
    "diskError3011": "파일 검증 실패, 파일을 다시 업로드하세요!",
    "diskError3012": "개인 클라우드 주소 가져오기 실패, 작업 실패!",
    "diskError3013": "여러 파일 조합은 100M를 초과할 수 없습니다. 큰 파일은 개별적으로 다운로드하세요!",
    "diskError3014": "압축 실패, 파일을 다시 선택하여 다운로드하세요!",
    "diskError3015": "이 작업을 수행하려면 권한이 필요합니다",
    "downloadError": "다운로드 실패!",
    "mobileError": "이동 실패!",
    "root": "모든 파일",
    "Name": "이름",
    "Size": "크기",
    "Type": "유형",
    "uploadFile": "파일 업로드",
    "newFolder": "새 폴더",
    "tableTime": "시간",
    "permission": "권한 부족!",
    "notifyTitle": "알림",
    "notifyContent": "사용자에게 액세스 권한이 부족합니다!",
    "sortFileName": "파일 이름",
    "sortTime": "시간",
    "sortSize": "크기",
    "sortType": "유형",
    "moveTo": "이동",
    "test": "새로 만들기",
    "delTitle": "삭제?",
    "delTitleContent": "선택한 내용이 데이터베이스에서 삭제됩니다. 이 작업은 되돌릴 수 없습니다. 계속하시겠습니까?",
    "delCancelButton": "취소",
    "delConfirmButton": "확인"
  },
  "userMge": {
    "userName": "사용자 이름:",
    "jobNumber": "사원 ID:",
    "email": "이메일:",
    "phone": "전화:",
    "group": "그룹:",
    "oldPassword": "기존 비밀번호:",
    "newPassword": "새 비밀번호:",
    "confirmNewPassword": "새 비밀번호 확인:",
    "btnSave": "변경 사항 저장",
    "titleChangePassword": "비밀번호 변경",
    "titleMyProfile": "내 프로필",
    "name": "닉네임:",
    "error1400": "계정(사용자 지정)이 이미 존재하여 작업 실패!",
    "error1401": "계정(시스템 생성)이 이미 존재하여 작업 실패!",
    "error1402": "그룹이 존재하지 않아 가져오기 실패!",
    "error1403": "데이터 오류",
    "error1404": "권한 부족",
    "selUser": "사용자를 선택하세요!",
    "error1405": "역할 가져오기 실패",
    "error1406": "가져온 사용자 정보 데이터 형식이 올바르지 않습니다",
    "error1407": "이메일이 이미 존재하여 작업 실패",
    "error1408": "전화번호가 이미 존재하여 작업 실패",
    "editSuccess": "저장 성공!",
    "ChangePassword": "비밀번호 변경",
    "UserPrivacyAgreement": "사용자 개인정보 정책"
  },
  "information": {
    "_2602": "장치 오프라인",
    "_2603": "방송 실패",
    "_2604": "방송이 중단되었습니다",
    "_2605": "클라우드 저장소가 가득 찼습니다",
    "_2606": "분 전",
    "_2607": "시간 전",
    "_2609": "장애가 발생했습니다, 부탁드립니다",
    "_2609_a": "여기를 클릭",
    "_2609_time": "제때 처리",
    "userType": "슈퍼 관리자",
    "unreadNoticeFirst": "읽지 않은 메시지 우선",
    "sortByTime": "시간별 정렬",
    "coxRead_1": "읽지 않음",
    "coxRead_0": "읽음",
    "allCoxRead": "모두 읽음으로 표시",
    "load": "로딩 중...",
    "noData": "더 이상 데이터가 없습니다",
    "viewALLMessages": "모든 메시지 보기"
  },
  "input": {
    "select": "선택하세요",
    "thisField": "이 필드는 반드시 입력해야 합니다.",
    "titleShooleNub60": "60자 미만",
    "titleShooleNub300": "300자 미만",
    "Offline": "오프라인"
  },
  "schedule": {
    "OnlyManual": "수동만",
    "runStartNow": "작업 실행",
    "runStopNow": "작업 중지",
    "tackExecutionStart": "작업 실행 중",
    "tackExecutionStop": "작업 실행 중지됨",
    "dehumidification": "제습",
    "airSupply": "공급",
    "masterControl": "메인:",
    "powerSupply": "전원",
    "lockScreen": "잠금",
    "RecordingControl": "녹화 제어",
    "RecordingControlSystem": "강의 캡처 시스템",
    "LiquidCrystal": "인터랙티브 LCD 디스플레이",
    "projector": "프로젝터",
    "othertype": "기타",
    "childLock": "차일드락",
    "energySaving": "절전",
    "signalSourceSwitching": "입력 소스",
    "other": "기타 기능:",
    "otherFunction": "기능",
    "send": "전송",
    "ON": "켬",
    "OFF": "끔",
    "btnAddSchedule": "복원",
    "EditSchedulelist": "스케줄러 편집",
    "AddSchedulelist": "스케줄러 추가",
    "RestoreSchedulelist": "복원",
    "btn": "취소",
    "btnNewList": "새 스케줄러",
    "ListName": "이름",
    "Cannotquit": "필수",
    "NOCannotquit": "아니요",
    "ListValidityPeriod": "유효 기간",
    "ListDescription": "설명",
    "currentSchedule": "스케줄러 목록",
    "historySchedule": "이력 목록",
    "selectTime": "시간",
    "selectTimeTable": "시간",
    "taskType": "작업 유형",
    "selectBroadcasting": "방송",
    "selectDeviveControl": "장치 제어",
    "newSchedule": "새 작업",
    "newChecklist": "새 체크리스트",
    "titleStatus": "상태",
    "titleType": "유형",
    "titleStartTime": "시작 시간",
    "titleEndTime": "종료 시간",
    "titleRepeat": "반복",
    "titleName": "이름",
    "titleAction": "동작",
    "tableEnabled": "활성",
    "tablePaused": "일시정지",
    "tableEdit": "편집",
    "tableDelete": "삭제",
    "tableVolumeEdit": "방송 볼륨",
    "tableBroadcastTitle": "제목",
    "tableBroadcastContent": "내용",
    "tableBroadcastList": "목록",
    "tableBroadcast": "강제",
    "btnRemoveCompletely": "완전히 제거",
    "btnEnabled": "활성 작업",
    "btnPaused": "작업 비활성화",
    "btnDelete": "삭제",
    "repeat0": "월",
    "repeat1": "화",
    "repeat2": "수",
    "repeat3": "목",
    "repeat4": "금",
    "repeat5": "토",
    "repeat6": "일",
    "dialogTitleAdd": "새 장치 제어 작업",
    "dialogTitleEdit": "장치 제어 작업 편집",
    "newBroadcastingSchedule": "새 방송 작업",
    "editBroadcastingSchedule": "방송 작업 편집",
    "chooseDevice": "장치 선택",
    "timeSetting": "시간 설정",
    "controlBroadcasting": "방송 옵션",
    "controlOption": "제어 옵션",
    "scheduleName": "작업 이름:",
    "destination": "대상",
    "timeTilte": "시간",
    "repeatTitle": "반복",
    "dialogRepeat0": "월",
    "dialogRepeat1": "화",
    "dialogRepeat2": "수",
    "dialogRepeat3": "목",
    "dialogRepeat4": "금",
    "dialogRepeat5": "토",
    "dialogRepeat6": "일",
    "dialogOnceType": "한 번",
    "dialogRepeatType": "반복",
    "Manual": "수동",
    "ManualContent": "설정 완료 후, 이 작업들을 수동으로 실행할 수 있습니다.",
    "mainPower": "주 전원",
    "powerControl": "전원 제어",
    "tableDisplayInputSwitch": "디스플레이 입력 전환",
    "tableAirConditioning": "에어컨",
    "tableProjectionScreen": "프로젝션 스크린",
    "tableElectronicLock": "전기 잠금장치",
    "interactiveFlatPanel": "Interactive Flat Panel",
    "displayInputSwitch": "디스플레이 입력 전환",
    "speakerVolume": "오디오 볼륨",
    "MICVolume": "마이크 볼륨",
    "ProjectionScreen": "투사 스크린",
    "ElectronicLock": "전기 잠금",
    "AirConditioning": "에어컨",
    "AirConditioningPower": "전원",
    "AirConditioningModel": "모델",
    "AirConditioningTEMP": "온도",
    "AirConditioningFanSpeed": "팬 속도",
    "OPEN": "열기",
    "CLOSE": "닫기",
    "UP": "위",
    "DOWN": "아래",
    "PowerOFF": "꺼짐",
    "PowerON": "켜짐",
    "ModelAuto": "자동",
    "ModelCool": "냉방",
    "ModelHeat": "난방",
    "ModelAir": "송풍",
    "TEMPLow": "낮음",
    "TEMPMiddle": "중간",
    "TEMPHigh": "높음",
    "btnSave": "저장",
    "btnNext": "다음",
    "StartTime": "시작 시간",
    "StopTime": "종료 시간",
    "Mandatory": "필수",
    "Video": "비디오 및 오디오",
    "Notification": "알림",
    "btnFile": "미디어 파일 선택",
    "LastingTime": "지속 시간",
    "textTitle": "제목",
    "textContent": "내용",
    "textTitleLetters": "60자 미만",
    "textContentLetters": "320자 미만",
    "CannotquitYES": "예",
    "CannotquitNo": "아니요",
    "YES": "예",
    "No": "아니요",
    "delTitleContent": "정말로 이 스케줄러를 삭제하시겠습니까?",
    "delTitleListContent": "삭제된 스케줄러는 이력 목록으로 이동되며 복원 가능합니다",
    "deleListTitle": "스케줄러를 삭제하시겠습니까?",
    "delTitleListContent1": "스케줄러를 삭제하면 관련 작업이 초기화됩니다. 확인해주세요.",
    "deleListTitle1": "정말로 이 스케줄러를 삭제하시겠습니까?",
    "delTitle": "삭제하시겠습니까?",
    "btnConfirm": "확인",
    "coxAll": "전체",
    "coxBroadcasting": "방송",
    "coxDeviveControl": "장치 제어",
    "rdMandatory": "예",
    "noRdMandatory": "아니요",
    "startDate": "시작일",
    "endedDate": "종료일",
    "or": "-",
    "broadcastingType": "유형",
    "ChooseTime": "시간 선택",
    "ChooseDate": "날짜 선택",
    "newScheduleList": "새 스케줄러",
    "editScheduleList": "스케줄러 편집",
    "listName": "이름",
    "listValidityPeriod": "유효 기간",
    "listDescription": "설명",
    "cancel": "취소",
    "confirm": "확인",
    "save": "저장",
    "addSuccess": "추가 성공!",
    "addError": "추가 실패!",
    "editSuccess": "편집 성공!",
    "editError": "편집 실패!",
    "delSuccess": "삭제 성공!",
    "delError": "삭제 실패!",
    "restoreSuccess": "스케줄 목록 복원 성공",
    "restoreError": "스케줄 목록 복원 실패",
    "restoreTitleContent": "이 시간은 목록의 스케줄 시간과 충돌합니다. 다시 선택해주세요",
    "Enabled": "활성",
    "Paused": "일시정지",
    "Title": "제목:",
    "Content": "내용:",
    "errorScheduleNameRequired": "작업 이름을 입력해야 합니다",
    "errorDeviceRequired": "대상 장치를 선택하세요",
    "deleTitle": "정말 이 작업을 삭제하시겠습니까?",
    "loopList": "루프 목록",
    "errorPleaseDateRange": "날짜 범위를 선택하세요",
    "addError_2009": "중복된 스케줄러 이름",
    "conflicts": "작업 시간이 다음과 충돌합니다:",
    "Pleaseagain": "다시 입력해주세요",
    "errorScheduleName": "작업 이름",
    "errorListName": "스케줄러 이름",
    "today": "오늘",
    "yesterday": "어제",
    "thisWeek": "이번 주",
    "lastWeek": "지난 주",
    "lastMonth": "지난 달",
    "thisMonth": "이번 달",
    "times": "횟수",
    "TimeConflicts": "시간 충돌",
    "editError_2006": "장치를 찾을 수 없습니다",
    "editError_2010": "중복 작업 이름",
    "editError_2100": "작업이 만료되어 시작할 수 없습니다.",
    "ListTimeExpired": "스케줄러 시간이 만료되었습니다. 다시 선택해주세요",
    "TimeExpired": "시간 만료",
    "ControlOption": "제어 옵션이 없습니다",
    "Pleaseleastone": "최소 하나의 제어 옵션을 선택하세요",
    "Enter": "입력",
    "TitleFilled": "제목은 필수입니다",
    "ContentFilled": "내용은 필수입니다",
    "PleaseMediaFile": "미디어 파일을 선택하세요",
    "PleaseSchedule": "작업을 선택하세요",
    "delTitleScheduleContent": "삭제된 작업은 복구할 수 없습니다.",
    "deleTitleSchedule": "정말 이 작업을 삭제하시겠습니까?",
    "deleteScheduleTitle": "삭제할 작업을 선택하세요",
    "PleaseFillColumn": "스케줄러 이름을 입력하세요",
    "PleaseDate": "날짜를 선택하세요",
    "Previous": "이전",
    "RemoteControl": "리모컨",
    "taskhasexpired": "이 작업은 만료되었습니다. 생성자에게 연락하여 시간을 업데이트하세요.",
    "execute": "실행",
    "broadcastingList": "방송 목록",
    "volumeSuccess": "볼륨 설정 성공",
    "volumeFailed": "볼륨 설정 실패"
  },
  "live": {
    "StreamingRoom": "스트리밍 룸",
    "btnAddNewRoom": "새 룸 추가",
    "Steaming": "스트리밍",
    "Creater": "호스트:",
    "Address": "RTMP 주소:",
    "StreamingURL": "라이브 스트리밍 URL:",
    "DestinationNMP": "대상 NMP 선택:",
    "stop": "중지",
    "stat": "시작",
    "btnCope": "클릭하여 복사",
    "QRcode": "QR 코드",
    "Refresh": "새로 고침",
    "AddNewRoomTitle": "새 스트리밍 룸 추가",
    "editNewRoomTitle": "스트리밍 룸 편집",
    "roomName": "룸 이름:",
    "cancel": "취소",
    "confirm": "확인",
    "save": "저장",
    "delTitleContent": "정말 이 스케줄을 삭제하시겠습니까?",
    "delTitle": "삭제하시겠습니까?",
    "delCancelButton": "취소",
    "delConfirmButton": "확인",
    "addSuccess": "추가 성공!",
    "addError": "추가 실패!",
    "editSuccess": "편집 성공!",
    "editError": "편집 실패!",
    "delSuccess": "삭제 성공!",
    "delError": "삭제 실패!",
    "Stopstreaming": "스트리밍 중지",
    "Startstreaming": "스트리밍 시작",
    "error2504": "미디어 서버의 라이브 스트리밍 주소를 가져올 수 없습니다",
    "error2505": "스트리밍 룸 이름이 중복됩니다",
    "error2506": "장치가 다른 스트리밍 신호에 의해 사용 중입니다",
    "error1900": "접근한 매개변수가 비어 있습니다",
    "error2503": "미디어 서버 정보를 가져올 수 없습니다",
    "error2507": "라이브 스트리밍 주소가 중복되었습니다",
    "copySuccess": "내용이 클립보드에 복사되었습니다.",
    "copyError": "브라우저가 자동 복사를 지원하지 않습니다",
    "flashControl": "Flash가 설치되지 않았거나 활성화되지 않았습니다. 설치 또는 활성화 후 다시 시도하세요.",
    "liveStreaming": "라이브 스트리밍 소스를 찾을 수 없습니다.",
    "btnflash": "설치/활성화",
    "serverAddress": "서버 주소",
    "addressKey": "키:",
    "watchingAddress": "시청 주소",
    "audioOnly": "오디오 전용",
    "enterTheKey": "키는 필수입니다."
  },
  "guidepages": {
    "next": "다음 제어 장치",
    "next1": "다음 제어 시도",
    "next2": "다음 방송",
    "next3": "다음 방송 시작",
    "next4": "다음 방송 중지",
    "next5": "다음 텍스트 방송",
    "next6": "다음 작업 설정",
    "next7": "다음 새 작업 추가",
    "next8": "다음 이력 목록",
    "next9": "다음 클라우드 스토리지",
    "next10": "다음 라이브 스트리밍",
    "next11": "다음 라이브 스트리밍 설정",
    "exit": "종료",
    "guideContent": "가이드 내용",
    "btnHomepage": "홈페이지",
    "btnDevices": "장치",
    "btnBroadcast": "방송",
    "btnSchedule": "스케줄",
    "btnResources": "리소스",
    "btnStreaming": "스트리밍",
    "btnPrevious": "이전"
  },
  "privacy": {
    "PrivacyPolicy": "Q-NEX Privacy Policy",
    "Byusing": "By using the Q-NEX service, you are trusting us to process your information. We understand that this responsibility is important, so we have been committed to protecting your information and giving you control.",
    "whatinformation": "This Privacy Policy is designed to help you understand what information we collect, why it is collected, and how you manage your information.",
    "EffectiveDate": "Effective Date: January 1, 2020",
    "title1": "Q-NEX Respects Your Privacy",
    "title1Respects1": "Returnstar Interactive Technology Group Co.,Ltd. and its sub-brand (collectively “Q-NEX”, “we” or “us”) respect your privacy and understand that the processing and security of your personal data is important to you. Please review the full Privacy Policy below for more complete details on how we collect, use, share, and protect your personal data, as well as the choices you have regarding our use and sharing of your personal data, along with other important considerations.",
    "title1Respects2": "This Privacy Policy explains Q-NEX’s practices regarding the processing (such as the collection, use, storage, copy or disclosure) of your personal data received: (i) through our website https://www.qnextech.com (“Website”), email, and other written or in person communications; (ii) in the context of all our commercial relations with customers, end-users, dealers, distributors, suppliers, contractors, agents or representatives; and (iii) in the normal course of any other potential business relationship. We commit to comply with our obligations under all applicable Privacy and Data Protection Laws, as described below, including but not limited to the Provisions on Protection of Personal Information of Telecommunications and Internet Users, and to respect your rights whenever we are processing your personal data.",
    "title2": "Privacy and Data Protection",
    "title2Respects1": "“Personal Data” means any information that identifies, or can be used to identify, an individual.",
    "title2Respects2": "“Privacy and Data Protection Laws” means any and/or all laws, rules, directives and regulations, on any local, provincial, state, federal or national level within and outside the People's Republic of China, pertaining to data privacy, data security and/or the protection of Personal Data. Among them, laws and regulations outside China include but not limited to: (a) the General Data Protection Regulation (GDPR) and each European Union Member States’ national implementation thereof; (b) the Australian Privacy Act 1988 (Cth) and the Australian Privacy Amendment (Enhancing Privacy Protection Act) (2012); (c) the Belgian Privacy Law of 8 December 1992; (d) the Canadian Personal Information Protection and Electronic Documents Act, SC 2000, c 5 (PIPEDA); (e) the Personal Data Protection Act 2012 of Singapore (PDPA); (f) additional privacy and data protection laws applicable to a data subject’s location; and (g) any successor legislation or regulations applicable thereto.",
    "title3": "When Do We Collect Your Personal Data?",
    "title3Respects1": "Q-NEX may collect your personal data when you communicate with us by phone, e-mail, the Website or otherwise, in the context of:",
    "title3a": "Browsing our Website or visiting our social media sites;",
    "title3b": "Corresponding with Q-NEX;",
    "title3c": "Visiting one of our offices, events or facilities;",
    "title3d": "Registering for and/or participating in our conferences, events, training or other activities;",
    "title3e": "Requesting information, support, service, materials, assistance or other inquiries;",
    "title3f": "Subscribing to a newsletter or other mailing list;",
    "title3g": "Exchanging business cards;",
    "title3h": "Completing Website contact forms, questionnaires, surveys, or contest entry forms or otherwise participating in these activities;",
    "title3i": "Engaging in commercial relationships or other collaboration;",
    "title3j": "Ordering or registering Q-NEX products;",
    "title3k": "Creating or registering an account;",
    "title3l": "Uploading or downloading files;",
    "title3m": "Verification of your identity as a data subject; or",
    "title3n": "Using Q-NEX products that are connected to the Internet, including mobile apps, cloudware, and certain hardware devices.",
    "title4": "Which Types of Personal Data are Processed by Us?",
    "title4Respects1": "Q-NEX may process the following personal data:",
    "title4a": "Name, surname, title, company, email address, phone number (mobile and landline), address, signature and other contact information;",
    "title4b": "IP addresses;",
    "title4c": "Location data;",
    "title4d": "Cookie ID;",
    "title4e": "Language;",
    "title4f": "Personal preferences regarding communications and/or products and services;",
    "title4g": "Financial details (e.g. payment information, bank account number, and credit information);",
    "title4h": "Personal data regarding projects using Q-NEX products and services;",
    "title4i": "Personal data provided in your submissions, responses and feedback;",
    "title4j": "Personal data regarding your interactions with Q-NEX, including your use of the Website and of Q-NEX’s products or services;",
    "title4k": "Social media data, images, photos, and camera footage; and",
    "title4l": "Any other personal data provided by you or by your authorized Q-NEX dealer or service provider.",
    "title4Respects2": "For the avoidance of doubt, Q-NEX does not collect any sensitive personal data, such as racial or ethnic origin; political opinions; religious or philosophical beliefs; genetic characteristics; health information; sexual preferences; information about children; criminal convictions; or biometric data, and we explicitly ask that you not provide us with such data in your responses or feedback to us.",
    "title5": "How Do We Use Your Personal Data?",
    "title5Respects1": "In order to better manage our own business needs and to better communicate with you, we may collect, analyze, use and otherwise process your personal data for the following purposes:",
    "title5a": "To respond to your inquiries, questions and other requests;",
    "title5b": "To optimize and manage the quality and content of our Website, including the ability to personalize and secure your Website experience;",
    "title5c": "To create and maintain your website, customer and product accounts and registrations;",
    "title5d": "To provide you with marketing, advertising, promotions, programs, offers and other opportunities; including newsletters, information on products and services, subscriptions, training, updates and direct marketing, which may be targeted, based on your communication preferences;",
    "title5e": "To conduct customer satisfaction studies, surveys and other market research;",
    "title5f": "To manage our events and activities, and invite you to events;",
    "title5g": "To register visitors to our offices, facilities and events;",
    "title5h": "To create promotional materials, including videos, photos, articles, case studies, newsletters and other materials regarding projects or events;",
    "title5i": "To provide products, services, training, technical support, customer service and other assistance;",
    "title5j": "To manage and perform our agreements and obligations;",
    "title5k": "To respond to and follow up on business leads, opportunities, and contacts;",
    "title5l": "To process payments, orders, invoicing, returns, collection and other requests;",
    "title5m": "To provide pricing, quotations and custom configurations of our products and services;",
    "title5n": "To grant you access to our software, training, technical information and other proprietary content;",
    "title5o": "To evaluate, troubleshoot, analyze and improve the use, functionality, features, and performance of our products, services, training, technical support and customer service;",
    "title5p": "To gather, analyze and maintain configuration and backup data regarding our products and services;",
    "title5q": "To facilitate planning, analytics, forecasting and reporting regarding our products and services;",
    "title5r": "To use for our internal business operations and processes, including business and financial recordkeeping, data management and business continuity; and",
    "title5s": "To meet our legal and regulatory obligations.",
    "title6": "Which Legal Basis Applies To Our Processing Of Your Personal Data?",
    "title6Respects1": "The following legal grounds might apply to the processing of your personal data for the purposes mentioned above:",
    "title6a": "Processing is necessary for the performance of your agreement with us or in order to take all pre-contractual steps;",
    "title6b": "Processing takes place based upon our legitimate interest (comply with obligations, maintain business records, fraud prevention, network and information security, etc.). When carrying out this type of processing, we strive to strike a balance between this legitimate interest and respect for your privacy;",
    "title6c": "You have given your consent to the processing (e.g. in case of direct marketing, for the processing of analytic cookies and for data transfers to third parties);",
    "title6d": "In order to comply with our legal obligations (such as tax administration and record retention); or",
    "title6e": "In very exceptional circumstances to protect your vital interest or that of someone else.",
    "titel7": "To Whom Do We Disclose Your Personal Data?",
    "title7Respects1": "Q-NEX may disclose your personal data to yourself, to Q-NEX’s affiliates or to third parties, such as payment providers, software providers, cloud partners, transport partners, financial institutions, insurance companies, legal services, or certain other service providers or partners that Q-NEX has a strategic relationship with, in order to fulfill our relationship with you in the most effective way.",
    "title7Respects2": "Q-NEX will not disclose to third parties any personal data you submit for purposes other than those described in this Privacy Policy. If, in the future, we intend to disclose your personal data to third parties for any purpose other than those described in this Privacy Policy we shall inform you thereof in advance and ask your consent if required.",
    "title7Respects3": "Notwithstanding the foregoing, Q-NEX will disclose your personal data to a third party (such as competent authorities) if required to do so by law, during a legal proceeding, or if, in good faith, Q-NEX believes that such action is necessary to comply with certain laws, rules or regulations.",
    "titel8": "Which Guarantees Do We Provide in Case of International Data Transfers?",
    "title8Respects1": "Q-NEX is a global company and we may transfer your information to Q-NEX affiliates, representatives or third party contractors who represent us worldwide. Each affiliate, representative, or third party contractor works closely with Q-NEX, and any transfer of personal data between these associated entities will comply with applicable Privacy and Data Protection Laws.",
    "title8Respects2": "If any transfer of the personal data of residents of the European Economic Area (EEA) is made to a person or entity located in a country outside of the EEA, that is not recognized as providing an adequate level of protection, we will provide for increased information security and appropriate contractual provisions to strengthen data protection. To ensure that any such transfers of the personal data of EEA residents are compliant with the applicable Privacy and Data Protection Laws, we will either (i) conclude a data transfer agreement, based upon the EU model agreements, (ii) adopt binding corporate rules, (iii) rely on legally determined exceptions (such as requesting your explicit consent) or (iv) adopt other mechanisms which have been deemed to provide for the adequate protection of your personal data.",
    "titel9": "How Do We Secure Your Personal Data?",
    "title9Respects1": "We use a variety of security technologies and precautions, such as the Secure Socket Layer (SSL) protocol (encryption), to help protect your personal data from loss, theft, misuse and unauthorized access, in accordance with industry standards. To protect any personal data stored on Q-NEX servers or cloud-based storage, we regularly monitor our systems for vulnerabilities or attacks, and implement up to date information security measures.",
    "title9Respects2": "Access to personal data that is processed by Q-NEX is limited only to those of its employees, contractors and affiliated organizations that need to know that information in order to process it on Q-NEX’s behalf, in accordance with this Privacy Policy, and that have agreed not to disclose it to others.",
    "titel10": "How Long Do We Retain Your Personal Data?",
    "title10Respects1": "Unless a longer retention period is required by law, Q-NEX will retain your personal data for as long as needed to fulfil the relevant purposes described in this Privacy Policy.",
    "titel11": "Use of Cookies",
    "title11Respects1": "Q-NEX uses cookies on our Website, both to enable the site to work properly, and to enhance your experience while visiting our Website. Cookie file(s), which are stored on the hard drive of your computer, enable us to obtain information about your usage of our Website, and to measure and improve the performance of our Website. Cookies enable you to store your preferences, in order to enable our Website to recognize these preferences when you browse our Website.",
    "title11Respects2": "You may refuse to accept cookies by activating the setting on your browser which allows you to refuse cookies. However, if you select this setting you may not be able to access certain sections or features of our Website. Unless you have adjusted your browser setting so that it will refuse cookies, our system will issue cookies to your computer whenever you log on to our Website.",
    "title11Respects3": "When you visit our Website for the first time you will be provided with a link to this cookie policy and will have the opportunity to change your browser settings to refuse cookies. By continuing to browse our website without changing your settings, you agree to our use of cookies as explained in this policy.",
    "title11Respects4GoogleAnalytics": "Google Analytics.",
    "title11Respects4": "We use industry standard web analytics to track visits to our sites, namely those provided by Google Analytics. The information generated by the cookies about your use of our Website (including your IP address) will be transmitted to and stored by Google Analytics on their servers and is handled in accordance with Google’s Privacy Policy which can be accessed at the following link: https://policies.google.com/privacy.",
    "titel12": "Third Party Links on our Website",
    "title12Respects1": "The Website contains links to other websites. Q-NEX is not responsible for the privacy policy of other websites, or the manner in which they store, use or distribute information. Q-NEX encourages you to review the privacy policy of any website you may visit.",
    "titel13": "Children’s Information",
    "title13Respects1": "Q-NEX’s Website is not intended for use by children, and its products and services are not sold to children. In accordance with the Children’s Online Privacy Protection Act, we do not collect or maintain information from persons we know are under 18, and no part of the Website is designed to attract anyone under age 18.",
    "titel14": "What Are Your Rights and How Can You Exercise Them?",
    "title14Respects1": "If you are a natural person, you have the right at all times to be informed about the personal data we process about you, and to the extent authorized under the applicable Privacy and Data Protection Laws, to request access, modification, limitation of processing, transfer or deletion of personal data, or to object to the processing of your personal data, subject to the exceptions within the applicable Privacy and Data Protection Laws.",
    "title14Respects2": "If processing is based solely on your consent, you also have the right to revoke your consent at any time, without prejudice to the lawfulness of processing prior to revocation.",
    "title14Respects3": "Through the contact options listed below, you can exercise the above rights regarding the processing of your personal data by Q-NEX, except in cases where this would require a disproportionate effort on the part of Q-NEX.",
    "title14Respects4": "Please feel free to use the contact information listed below if you have any additional concerns regarding your personal data or your exercise of the above rights, and we will do our best to assist you.",
    "title14Respects5": "If you contact us to exercise one of your rights under the applicable Privacy and Data Protection Laws, we will reply within one (1) month. In certain exceptional circumstances, we may take up to three (3) months to fully respond to you, but in such case we shall inform you why we require additional time to respond in our initial reply.",
    "title14Respects6": "If we are unable to resolve an inquiry or request, where applicable, you may have the right to lodge a complaint with the local data protection authority.",
    "titel15": "Stay Informed of Changes in Our Privacy Policy",
    "title15Respects1": "In a world in which technology and legislation is constantly changing, this Privacy Policy may also change. We invite you to always consult the latest version of this policy, posted at https://www.qnextech.com/legal, and we will inform you of any changes via our Website or other common communication channels.",
    "titel16": "Contact Q-NEX",
    "title16Respects1": "If you have questions and/or comments about this Privacy Policy or the manner in which Q-NEX collects, uses and/or processes your personal data, please contact us:",
    "title16Respects2": "Via e-mail: info@qnextech.com"
  }
}



// WEBPACK FOOTER //
// ./src/lang/ko.js